import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {Country} from "../../region/types/Country";
import {getCountryName} from "../../region/utils/get_country_name";
import {IGtmProduct} from "../types/IGtmProduct";
import {calculateGtmDimensions, IGtmOffer, IGtmRegion, IGtmVendor} from "./calculate_gtm_dimensions";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IGtmInvest extends Omit<IGtmProduct, "home_listing_id"> {}

interface IGtmInvestDetail {
    event: "invest_detail";
    details: IGtmInvest;
}

interface IIdFields {
    name: string;
    id: string;
    group_id: string;
}

const gtmInvestDetail = (idFields: IIdFields, region: IGtmRegion, vendor: IGtmVendor, offer: IGtmOffer, country: Country) => {
    const customCountry = getCountryName(country);

    // calculate invest
    const invest: IGtmInvest = {
        ...calculateGtmDimensions(region, offer),
        ...idFields,
        price: "1.00",
        brand: vendor ? `${vendor.id}/${vendor.name}` : "na",
        category: `${offer.id}/${offer.name}`,
        variant: "na",
        quantity: 1,
        custom_country: customCountry
    };
    // prepare gtm data and hit
    const gtmData: IGtmInvestDetail = {
        event: "invest_detail",
        details: invest
    };
    hitGoogleTagManager(gtmData);
    return true;
};

/**
 * Specific actions
 */

export const gtmInvestDetailOnOfferDetail = (offer: IOfferDetail) => {
    const id = `PR${offer.id}`;
    const groupId = `${offer.id}-0`;
    const flatOffer: IGtmOffer = {...offer, region: offer.region.id, vendor: offer.vendor.id};
    const country = offer.region.country;

    return gtmInvestDetail({name: offer.name, id, group_id: groupId}, offer.region, offer.vendor, flatOffer, country);
};
import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {Country} from "../../region/types/Country";
import {getCountryName} from "../../region/utils/get_country_name";
import {IGtmProduct} from "../types/IGtmProduct";
import {calculateGtmDimensions, IGtmOffer, IGtmRegion, IGtmVendor} from "./calculate_gtm_dimensions";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IGtmInvest extends Omit<IGtmProduct, "home_listing_id"> {}

interface IGtmInvestDetail {
    event: "invest_detail";
    details: IGtmInvest;
}

interface IIdFields {
    name: string;
    id: string;
    group_id: string;
}

const gtmInvestDetail = (idFields: IIdFields, region: IGtmRegion, vendor: IGtmVendor, offer: IGtmOffer, country: Country) => {
    const customCountry = getCountryName(country);

    // calculate invest
    const invest: IGtmInvest = {
        ...calculateGtmDimensions(region, offer),
        ...idFields,
        price: "1.00",
        brand: vendor ? `${vendor.id}/${vendor.name}` : "na",
        category: `${offer.id}/${offer.name}`,
        variant: "na",
        quantity: 1,
        custom_country: customCountry
    };
    // prepare gtm data and hit
    const gtmData: IGtmInvestDetail = {
        event: "invest_detail",
        details: invest
    };
    hitGoogleTagManager(gtmData);
    return true;
};

/**
 * Specific actions
 */

export const gtmInvestDetailOnOfferDetail = (offer: IOfferDetail) => {
    const id = `PR${offer.id}`;
    const groupId = `${offer.id}-0`;
    const flatOffer: IGtmOffer = {...offer, region: offer.region.id, vendor: offer.vendor.id};
    const country = offer.region.country;

    return gtmInvestDetail({name: offer.name, id, group_id: groupId}, offer.region, offer.vendor, flatOffer, country);
};
